import useSWR from "swr";

import * as fetcher from "../fetcher";

export interface UserGroups {
  id: string;
  displayName: string;
}

interface UserAccess {
  value: UserGroups[];
  "@odata.nextLink"?: string;
}

const isInSalesLeadGroup = (groups: UserGroups[]) =>
  groups.some(
    (group: UserGroups) =>
      group.id === import.meta.env.VITE__AZ_USER_GROUP ||
      group.id === import.meta.env.VITE__AZ_ADMIN_GROUP
  );

const isUserInGroups = async (nextPageLink?: string) => {
  // Fetch from either the base URL or the next page link
  const response = await fetcher.graph.get<UserAccess>(
    nextPageLink ?? "/me/memberOf?$select=id,displayName"
  );

  // Check if the user is in the sales lead group
  if (isInSalesLeadGroup(response.value)) {
    return true;
  }

  // If there is a next page link, fetch from it
  if (response["@odata.nextLink"]) {
    const nextLink = response["@odata.nextLink"].substring(32); // Remove the base graph URL
    return await isUserInGroups(nextLink);
  }

  // no match
  return false;
};

export const useUserAccess = () => {
  return useSWR<boolean>(
    "/me/memberOf?$select=id,displayName",
    isUserInGroups,
    {
      errorRetryCount: 3,
      revalidateOnFocus: false,
      dedupingInterval: 10 * 60 * 1000,
    }
  );
};
